import React, { useState } from "react";

const TextInputPopup = ({ isOpen, onClose, onSubmit, title = "Input Check" }) => {
  const [inputValue, setInputValue] = useState("");

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(inputValue);
    setInputValue("");
    onClose();
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <h2>{title}</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Enter response..."
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            className="popup-input"
            autoFocus
          />
          <div className="popup-actions">
            <button type="submit" className="popup-button primary">Submit</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TextInputPopup;
